/* AFTER FOUR v59 — nine-product automatic hero. No pack rotation or altered packaging.
   Mouse/keyboard/touch accessible; pause when off screen or motion-reduced. */
(() => {
  'use strict';
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initHero = (scope = document) => {
    scope.querySelectorAll('[data-af56-hero]').forEach((hero) => {
      if (hero.dataset.af59Ready === 'true') return;
      hero.dataset.af59Ready = 'true';
      const stage = hero.querySelector('.af56-hero__stage');
      const carousel = hero.querySelector('[data-af59-swipe]');
      const slides = [...hero.querySelectorAll('[data-af56-slide]')];
      const thumbnails = [...hero.querySelectorAll('[data-af56-slide-button]')];
      const tabs = [...hero.querySelectorAll('[data-af59-tab]')];
      const flavour = hero.querySelector('[data-af56-selected-name]');
      const categoryText = hero.querySelector('[data-af56-selected-kind]');
      const counter = hero.querySelector('[data-af56-count]');
      const cta = hero.querySelector('[data-af56-current-link]');
      const strip = hero.querySelector('.af56-hero__switcher');
      const progress = hero.querySelector('[data-af59-progress]');
      if (!stage || !carousel || !slides.length || thumbnails.length !== slides.length) return;
      let active = 0;
      let category = 'makhana';
      let visible = false;
      let timer = null;
      let touchX = null;
      let touchY = null;
      const catIndexes = cat => slides.map((el,i) => el.dataset.af59Category === cat ? i : -1).filter(i => i>=0);
      const stop = () => {
        if (timer != null) { clearInterval(timer); timer = null; }
        hero.classList.remove('is-playing');
      };
      const resetProgress = () => {
        if (!progress) return;
        progress.style.animation = 'none';
        void progress.offsetWidth;
        progress.style.animation = '';
      };
      const start = () => {
        stop();
        resetProgress();
        if (reduce() || document.hidden || !visible || catIndexes(category).length < 2) return;
        hero.classList.add('is-playing');
        timer = setInterval(() => {
          const list = catIndexes(category);
          const at = list.indexOf(active);
          switchTo(list[(at + 1) % list.length], true);
          resetProgress();
        },6000);
      };
      const centerThumbnail = index => {
        if (!strip || !thumbnails[index]) return;
        const btn = thumbnails[index];
        const left = btn.offsetLeft - strip.offsetLeft - (strip.clientWidth - btn.clientWidth) / 2;
        strip.scrollTo({left:Math.max(0,left),behavior:reduce()?'auto':'smooth'});
      };
      const switchTo = (index, scrollStrip) => {
        if (index < 0 || index >= slides.length) return;
        active = index;
        const slide = slides[index];
        slides.forEach((item,i) => {
          const chosen = i === index;
          item.classList.toggle('is-active',chosen);
          item.setAttribute('aria-hidden',String(!chosen));
        });
        thumbnails.forEach((item,i) => {
          const chosen = i === index;
          item.classList.toggle('is-active',chosen);
          item.setAttribute('aria-pressed',String(chosen));
        });
        stage.style.setProperty('--af56-slide-tone',slide.dataset.color || '#c7dce9');
        if (flavour) flavour.textContent = slide.dataset.name || '';
        if (categoryText) categoryText.textContent = slide.dataset.kind || '';
        if (cta && slide.dataset.url) cta.href = slide.dataset.url;
        const list = catIndexes(category);
        if (counter) counter.textContent = String(list.indexOf(index)+1).padStart(2,'0')+' / '+String(list.length).padStart(2,'0');
        if (scrollStrip) centerThumbnail(index);
      };
      const changeCategory = cat => {
        const list = catIndexes(cat);
        if (!list.length) return;
        category = cat;
        tabs.forEach(tab => {
          const chosen = tab.dataset.af59Tab === cat;
          tab.classList.toggle('is-active',chosen);
          tab.setAttribute('aria-pressed',String(chosen));
        });
        thumbnails.forEach(btn => {btn.hidden = btn.dataset.af59Category !== cat;});
        switchTo(list[0],false);
        if (strip) strip.scrollLeft = 0;
        start();
      };
      tabs.forEach(tab => tab.addEventListener('click', () => changeCategory(tab.dataset.af59Tab)));
      thumbnails.forEach((button,index) => {
        button.addEventListener('click',() => {
          if (button.hidden) return;
          switchTo(index,true);
          start();
        });
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const list = catIndexes(category);
          const pos = list.indexOf(index);
          const next = list[(pos + (event.key === 'ArrowRight'?1:-1) + list.length)%list.length];
          thumbnails[next].focus();
          switchTo(next,true);
          start();
        });
      });
      carousel.addEventListener('touchstart',event => {
        if (event.changedTouches.length !== 1) return;
        touchX = event.changedTouches[0].clientX;
        touchY = event.changedTouches[0].clientY;
      },{passive:true});
      carousel.addEventListener('touchend',event => {
        if (touchX===null || event.changedTouches.length!==1) return;
        const dx = event.changedTouches[0].clientX - touchX;
        const dy = event.changedTouches[0].clientY - touchY;
        touchX = touchY = null;
        if (Math.abs(dx)<42 || Math.abs(dx)<Math.abs(dy)) return;
        const list = catIndexes(category);
        const pos = list.indexOf(active);
        switchTo(list[(pos + (dx<0?1:-1) + list.length)%list.length],true);
        start();
      },{passive:true});
      stage.addEventListener('mouseenter',stop);
      stage.addEventListener('mouseleave',start);
      stage.addEventListener('focusin',stop);
      stage.addEventListener('focusout',event => {if (!stage.contains(event.relatedTarget)) start();});
      document.addEventListener('visibilitychange',() => document.hidden?stop():start());
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.isIntersecting);
          if (visible) start(); else stop();
        },{threshold:.15});
        observer.observe(stage);
      } else visible = true;
      changeCategory('makhana');
    });
  };
  const initJump = (scope=document) => {
    scope.querySelectorAll('[data-af59-jump]').forEach(link => {
      if (link.dataset.af59Ready) return;
      link.dataset.af59Ready = 'true';
      link.addEventListener('click',event => {
        const kind = link.dataset.af59Jump;
        const shop = document.querySelector('#af49-shop');
        const filter = shop?.querySelector('[data-af49-filter="'+kind+'"]');
        if (!shop || !filter) return;
        event.preventDefault();
        filter.click();
        shop.scrollIntoView({behavior:reduce()?'auto':'smooth',block:'start'});
        if (history.replaceState) history.replaceState(null,'','#af49-shop');
      });
    });
  };
  const initMini = (scope=document) => {
    scope.querySelectorAll('[data-af56-teaser]').forEach(container => {
      if (container.dataset.af56Ready==='true') return;
      container.dataset.af56Ready='true';
      const button = container.querySelector('[data-af56-show-more]');
      if (!button) return;
      let expanded=false;
      const paint=(open,filtered)=>{
        container.dataset.af56Expanded=String(open);
        button.hidden=Boolean(filtered);
        button.setAttribute('aria-expanded',String(open));
        button.textContent=open?'SHOW FEWER FLAVOURS −':'SEE ALL NINE FLAVOURS +';
      };
      paint(false,false);
      button.addEventListener('click',()=>{expanded=!expanded;paint(expanded,false);});
      container.closest('[data-af52-mini]')?.querySelectorAll('[data-af52-mini-filter]').forEach(tab=>{
        tab.addEventListener('click',()=>paint(tab.dataset.af52MiniFilter==='all'?expanded:true,tab.dataset.af52MiniFilter!=='all'));
      });
    });
  };
  const init = (scope=document) => {initHero(scope);initJump(scope);initMini(scope);};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
  else init();
  document.addEventListener('shopify:section:load',event=>init(event.target||document));
})();